<template>
  <div class="container">
    <div id="accordion">
      <div class="card">
        <div class="card-header" id="headingOne">
          <h5 class="mb-0">
            <button
              class="btn btn-link"
              data-toggle="collapse"
              data-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Upload News and Events
            </button>
          </h5>
        </div>

        <div
          id="collapseOne"
          class="collapse show"
          aria-labelledby="headingOne"
          data-parent="#accordion"
        >
          <div class="card-body">
            <form @submit.prevent="upload">
              <div class="form-group ">
                <label for="event_title">Event Title:</label>
                <input
                  type="text"
                  name="event_title"
                  class="form-control"
                  id="event_title"
                  v-model="events.event_title"
                />
              </div>

              <div class="form-group  ">
                <label for="event-description">Event Desctiption:</label>
                <textarea
                  class="form-control"
                  name="event-description"
                  id="event-description"
                  rows="7"
                  v-model="events.event_description"
                >
                </textarea>
              </div>

              <div class="form-group ">
                <button type="submit" class="btn btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      events: {
        event_title: "",
        event_description: ""
      }
    };
  },

  methods: {
    upload() {
      window.axios.post("/api/events", this.events).then(res => {
        console.log(res.data);
      });
    }
  }
};
</script>
